//TODO REFACTOR rename to InvestorKycStatus - D.Zghinnik
export enum KYC_STATUS {
	NOT_SENT_OUT = 'NOT_SENT_OUT',
	AWAITING_INVESTOR = 'AWAITING_INVESTOR',
	PENDING_APPROVAL = 'PENDING_APPROVAL',
	COMPLETED = 'COMPLETED',
	NOT_REQUIRED = 'NOT_REQUIRED',
}

//TODO REFACTOR change name to TransactionActionType to not confuse with TransactionType - D.Zghinnik
export enum TRANSACTION_TYPE {
	BUY = 'BUY',
	SELL = 'SELL',
}

export enum InvestorInvitationStatus {
	NOT_INVITED = 'NOT_INVITED',
	INVITED = 'INVITED',
	ACTIVE = 'ACTIVE',
}

export enum InvestorInvestmentStatus {
	CREATED = 'CREATED',
	RELEASED = 'RELEASED',
}

export enum InvestorMode {
	CREATE = 'CREATE',
	JOINER = 'JOINER',
	LEAVER = 'LEAVER',
}

export enum MipMode {
	JOINER = 'JOINER',
	LEAVER = 'LEAVER',
}

/** Largest selection the synchronous investors download serves; bigger ones go through the async export workflow (MIP-2838). */
export const INVESTOR_SYNC_DOWNLOAD_MAX_COUNT = 20;
